<div class="activities-section" *ngIf="selected_page_action == 'Activities'">
    <!-- <ng-container *ngTemplateOutlet="activitiesSection;"></ng-container> -->
    <ng-container *ngIf="activities_loader">
        <!-- <app-loader [loading_text]="'Loading'"></app-loader> -->
        <div style="text-align: center; padding: 40px 0; color: #006aff;">
            <h3>Loading Activities ...</h3>
        </div>
    </ng-container>
    <!-- <ng-container *ngIf="!activities_loader"> -->
    <!-- <div [ngClass]="{'hide-section': activities_loader, 'show-section': !activities_loader}"> -->
    <!-- <div [ngStyle]="{'visibility': activities_loader ? 'hidden': 'unset' }"> -->
    <div [ngClass]="{'hide-section': activities_loader, 'show-section': !activities_loader}">
        <app-activity-table [activities_table_header]="activities_table_header" [activities_table_data]="activities" [view_type]="'Activities'" [activity_user_data]="selected_user_data" [activity_action_type]="activity_action_type" [selected_activity_type]="selected_activity_type" [stepper_stage]="stepper_stage" [coaching_plan]="coaching_plan" [selected_activity_type_id]="selected_activity_type_id" (activityDetailsUpdated)="activityDetailsUpdated($event)"></app-activity-table>
    </div>
</div>

<div class="activities-section" *ngIf="selected_page_action == 'Products'">
    <ng-container>
        <div class="inner-tabs-section">
            <div class="each-inner-tab-section" [ngClass]="{'each-inner-tab-section-selected': inner_product_tab == 'Add Product'}" (click)="inner_product_tab = 'Add Product'">
                <span>Add Product</span>
            </div>
            <div class="each-inner-tab-section" [ngClass]="{'each-inner-tab-section-selected': inner_product_tab == 'View All Products'}" (click)="inner_product_tab = 'View All Products'; getClientProducts(selected_user_data)">
                <span>View All Products</span>
            </div>
        </div>
        <div *ngIf="inner_product_tab == 'Add Product'">
            <!-- <ng-container *ngTemplateOutlet="productConversionSection;"></ng-container> -->
            <ng-container *ngIf="user_details.role.business_area[0] == '5'">
                <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
            </ng-container>
            <ng-container *ngIf="user_details.role.business_area[0] == '6'">
                <ng-container *ngTemplateOutlet="depositProductOperationSection;"></ng-container>
            </ng-container>
            <ng-container *ngIf="user_details.role.business_area[0] == '7'">
                <ng-container *ngTemplateOutlet="lendingProductOperationSection;"></ng-container>
            </ng-container>
            <ng-container *ngIf="user_details.role.business_area[0] == '8'">
                <ng-container *ngTemplateOutlet="insuranceProductOperationSection;"></ng-container>
            </ng-container>
            <div class="activities-button-section">
                <button class="page-modal-primary-button" (click)="addProduct()">Save</button>
                <button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
            </div>
        </div>
        <div *ngIf="inner_product_tab == 'View All Products'">
            <!-- <ng-container *ngTemplateOutlet="productsSection;"></ng-container> -->
            <ng-container *ngIf="user_details.role.business_area[0] == '5'">
                <ng-container *ngTemplateOutlet="productsSection;"></ng-container>
            </ng-container>

            <ng-container *ngIf="user_details.role.business_area[0] == '6'">
                <ng-container *ngTemplateOutlet="depositProductsSection;"></ng-container>
            </ng-container>

            <ng-container *ngIf="user_details.role.business_area[0] == '7'">
                <ng-container *ngTemplateOutlet="lendingProductOperationSection;"></ng-container>
            </ng-container>
            <ng-container *ngIf="user_details.role.business_area[0] == '8'">
                <ng-container *ngTemplateOutlet="insuranceProductOperationSection;"></ng-container>
            </ng-container>
        </div>
    </ng-container>
</div>

<ng-template #activitiesSection>
    <div class="add-activity-section" *ngIf="selected_view_type != 'View'">
        <button class="page-modal-primary-button" (click)="resetActivityData(); activityOpeartion(activity_data, 'Add', 'Add Activity', null)">Add Activity</button>
    </div>
    <div class="activities-inner-view-section" *ngIf="activity_opeartion_selected == 'Add Activity'">
        <div class="innner-heading-section">
            <span>{{activity_operation_type}} Activity</span>
        </div>
        <ng-container *ngTemplateOutlet="activityOperationSection;"></ng-container>
        <div class="activities-button-section">
            <button class="page-modal-primary-button" (click)="saveTaskData()">Save</button>
            <button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
        </div>
    </div>
    <div class="automated-activities-section">
        <!-- <div class="automated-activities-header-section">
            <div class="automated-activities-heading-section">
                <img src="assets/automated-activities.png" class="automated-activities-heading-icon" />
                <span>Activities</span>
            </div>
        </div> -->
        <div class="automated-activities-content-section">
            <ng-container *ngIf="!activities_loader">
                <!-- <div class="activities-button-section" *ngIf="selected_activities.length > 0">
                    <button class="page-modal-primary-button" (click)="openAutomatedActivityOperationModal(selected_activities, '')">Stop Activities</button>
                    <button class="page-modal-secondary-button" (click)="selected_activities = [];">Cancel</button>
                </div> -->
                <div class="activity-table-section">
					<table class="activity-table">
						<thead>
							<tr>
								<th appColumnResizable *ngIf="selected_view_type != 'View'">Actions</th>
								<!-- <th appColumnResizable>Actions</th> -->
								<th appColumnResizable *ngFor="let column of activities_table_header">{{column.name}}</th>
							</tr>
						</thead>
						<tbody *ngIf="activities.length > 0">
							<ng-container *ngFor="let activity of activities; let index = index;">
								<tr [ngClass]="{'manual-task-bg': activity.activity_type != 1}">
									<td style="overflow: visible;" *ngIf="selected_view_type != 'View'">
                                    <!-- <td style="overflow: visible;"> -->
										<!-- <div class="activity-checkbox-section" *ngIf="notification_item_selected != 'completed task'">
											<mat-checkbox [checked]="checkIndividualSelection(activity)"
											(change)="selectIndividual($event, activity)"></mat-checkbox>
										</div> -->
										<div class="more-details-section" *ngIf="selected_view_type != 'View'">
											<img src="assets/more-icon.png" class="more-details-icon" (click)="toggleActivityOptionsView(index)" />
											<div class="more-options-section" *ngIf="show_more_options == index">
												<p class="each-more-option" (click)="resetActivityData(); openEmail(activity)" *ngIf="activity.communication_type_name == 'Email'">Send Email</p>
												<p class="each-more-option" (click)="resetActivityData(); activityOpeartion(activity_data, 'Add', 'Activity Operations', index)">Add Activity</p>
												<p class="each-more-option" *ngIf="activity.activity_type != 1" (click)="resetActivityData(); activityOpeartion(activity, 'Edit', 'Activity Operations', index)">Edit Activity</p>
                                                <ng-container *ngIf="user_role == 'Advisor' || user_role == 'AFA' || user_role == 'Relationship Manager'">
                                                    <p class="each-more-option" *ngIf="activity.afa_name == '' || activity.afa_name == null || activity.afa_name == 'Self'" (click)="resetActivityData(); openAssignActivitySection(activity, 'Reassign Activity', index)">Reassign Activity</p>
                                                    <p class="each-more-option" *ngIf="activity.afa_name != '' && activity.afa_name != null && activity.afa_name != 'Self'" (click)="resetActivityData(); unassignActivity(activity)">Unassign Activity</p>
                                                </ng-container>
												<p class="each-more-option" *ngIf="!activity.activity_paused" (click)="resetActivityData(); openAutomatedActivityOperationModal(activity, 'Individual')">Stop Activity</p>
												<p class="each-more-option" *ngIf="activity.activity_paused" (click)="resetActivityData(); openAutomatedActivityOperationModal(activity, 'Individual')">Resume Activity</p>
                                                <ng-container *ngIf="(user_role == 'Assistant')">
                                                    <p class="each-more-option" *ngIf="activity.notify == false" (click)="resetActivityData(); openNotifyActivitySection(activity, 'Notify Activity', index)">Notify Activity</p>
                                                </ng-container>
												<p class="each-more-option" *ngIf="activity.activity_type != 1" (click)="resetActivityData(); removeActivity(activity)">Delete Activity</p>
												<p class="each-more-option" (click)="resetActivityData(); openCommentsSection(activity, 'Comments', index)">Comments</p>
												<p class="each-more-option" (click)="resetActivityData(); openAttachmentsSection(activity, 'Attachments', index)">Attachments</p>
												<!-- <p class="each-more-option" *ngIf="(user_role == 'Advisor') && (activity.stage == 'Pitch(Sales)' || activity.stage == 'Follow Up(Sales)')" (click)="resetActivityData(); openProductsSection(activity, 'Products', index)">Close Deal</p> -->
												<p class="each-more-option" *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity.afa_name == '' || activity.afa_name == null || activity.afa_name == 'Self'))) && (activity.activity_type == 1 || activity.activity_type == 2)" (click)="resetActivityData(); openProductsSection(activity, 'Products', index)">Close Deal</p>
												<!-- <p class="each-more-option" *ngIf="(user_role == 'Advisor') && (activity.stage == 'Pitch(Retention)' || activity.stage == 'Follow Up(Retention)')" (click)="resetActivityData(); openOutcomeSection(activity, 'Outcome', index)">Change Outcome</p> -->
												<p class="each-more-option" *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity.afa_name == '' || activity.afa_name == null || activity.afa_name == 'Self'))) && (activity.activity_type == 3 || activity.activity_type == 5)" (click)="resetActivityData(); openOutcomeSection(activity, 'Outcome', index)">Change Outcome</p>
											</div>
										</div>
                                        <ng-container>
                                            <ng-container *ngIf="user_role != 'Advisor Manager'">
                                                <button class="activity-table-button" *ngIf="!activity.capture_response.captured_response" (click)="resetActivityData(); captureResponseData(activity, index, 'Capture Response')">Capture Response</button>
                                                <button class="activity-table-button" *ngIf="activity.capture_response.captured_response" (click)="resetActivityData(); captureResponseData(activity, index, 'Capture Response')">View/Edit Response</button>
                                            </ng-container>
                                        </ng-container>
                                        <!-- <ng-container *ngIf="user_role != 'Advisor Manager'">
                                            <button class="activity-table-button" (click)="sendNotification(activity, index)">Send Notification</button>
                                        </ng-container> -->
									</td>
									<ng-container *ngFor="let column of activities_table_header" [ngSwitch]="column.key">
										<ng-container *ngSwitchCase="'name'">
											<td class="overflow-section">
												<!-- <p class="activity-name" (click)="showActivityDetails(activity)">{{activity.name}}</p> -->
												<p class="activity-name" [ngClass]="{'automated-activity-name': (activity.activity_type == 1) || (activity.activity_type == 4) || (activity.activity_type == 5)}" (click)="openActivityEmailPreviewModal(activity)">{{activity.name}}</p>
											</td>
										</ng-container>
										<ng-container *ngSwitchCase="'scheduled_date'">
											<td>
												{{activity.scheduled_date | date: "dd MMM yyyy"}}
											</td>
										</ng-container>
                                        <ng-container *ngSwitchCase="'actual_date'">
											<td>
												{{activity.actual_date | date: "dd MMM yyyy"}}
											</td>
										</ng-container>
										<ng-container *ngSwitchCase="'status_name'">
											<td [ngClass]="{ 'activity-status-pending': activity.status_name == 'Pending', 'activity-status-progress':  activity.status_name == 'In Progress', 'activity-status-completed': activity.status_name == 'Completed'}">{{activity.status_name}}</td>
										</ng-container>
										<ng-container *ngSwitchCase="'activity_type'">
											<td>
												<span *ngIf="(activity.activity_type != 1) && (activity.activity_type != 4) && (activity.activity_type != 5)" class="manual-task-status">Manual</span>
												<span *ngIf="(activity.activity_type == 1) || (activity.activity_type == 4) || (activity.activity_type == 5)">Automated</span>
											</td>
										</ng-container>
                                        <ng-container *ngSwitchCase="'lead_advisor_full_name'">
											<td>
                                                <span *ngIf="activity.lead_advisor_full_name != '' && activity.lead_advisor_full_name != null" (click)="openAssignCommentsSection('Assign Comments', index)" style="cursor: pointer;">{{activity.lead_advisor_full_name}}</span>
                                                <span *ngIf="activity.lead_advisor_full_name == '' || activity.lead_advisor_full_name == null">-</span>
                                            </td>
										</ng-container>
                                        <ng-container *ngSwitchCase="'afa_name'">
											<td>
                                                <span *ngIf="activity.afa_name != '' && activity.afa_name != null">{{activity.afa_name}}</span>
                                                <span *ngIf="activity.afa_name == '' || activity.afa_name == null">-</span>
                                            </td>
										</ng-container>
                                        <ng-container *ngSwitchCase="'notified_by'">
											<td>
                                                <span *ngIf="activity.notified_by != '' && activity.notified_by != null" (click)="openNotifyCommentsSection(activity, 'Notify Comments', index)" style="cursor: pointer;">{{activity.notified_by}}</span>
                                                <span *ngIf="activity.notified_by == '' || activity.notified_by == null">-</span>
                                            </td>
										</ng-container>
										<ng-container *ngSwitchCase="'description'">
											<td class="overflow-section" [innerHTML]="activity.description"></td>
										</ng-container>
										<ng-container *ngSwitchDefault>
											<!-- <td [matTooltip]="getKey(activity, column)">{{getKey(activity, column)}}</td> -->
											<td>{{getKey(activity, column)}}</td>
										</ng-container>
									</ng-container>
								</tr>
								<tr *ngIf="show_inner_view == index">
									<!-- <td [attr.colspan]="activities_table_header.length + 1"> -->
                                    <td colspan="7">
										<div class="activities-inner-view-section">
											<ng-container *ngIf="activity_opeartion_selected == 'Capture Response'">
												<div class="innner-heading-section">
													<!-- <span>Capture Response</span> -->
													<span>Response</span>
												</div>
												<ng-container *ngTemplateOutlet="captureResponseSection;"></ng-container>
												<div class="inner-checkbox-section">
													<mat-checkbox [(ngModel)]="show_follow_up_task">Add Follow-Up Activity</mat-checkbox>
												</div>
												<ng-container *ngIf="show_follow_up_task">
													<div class="innner-heading-section">
														<span>{{activity_operation_type}} Activity</span>
													</div>
													<ng-container *ngTemplateOutlet="activityOperationSection;"></ng-container>
												</ng-container>
                                                <ng-container *ngIf="(user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity.afa_name == '' || activity.afa_name == null || activity.afa_name == 'Self'))">
                                                    <!-- <ng-container *ngIf="(activity.stage == 'Pitch(Sales)' || activity.stage == 'Follow Up(Sales)')"> -->
                                                    <ng-container *ngIf="(activity.activity_type == 1 || activity.activity_type == 2)">
                                                        <div class="inner-checkbox-section">
                                                            <mat-checkbox [(ngModel)]="show_close_deal">Close Deal</mat-checkbox>
                                                        </div>
                                                        <ng-container *ngIf="show_close_deal">
                                                            <div class="innner-heading-section">
                                                                <span>Add Product</span>
                                                            </div>
                                                            <ng-container *ngTemplateOutlet="productConversionSection;"></ng-container>
                                                        </ng-container>
                                                    </ng-container>
                                                    <!-- <ng-container *ngIf="(activity.stage == 'Pitch(Attrition)' || activity.stage == 'Follow Up(Attrition)')"> -->
                                                    <ng-container *ngIf="(activity.activity_type == 3 || activity.activity_type == 5)">
                                                        <div class="inner-checkbox-section">
                                                            <mat-checkbox [(ngModel)]="show_close_deal">Add Outcome</mat-checkbox>
                                                        </div>
                                                        <ng-container *ngIf="show_close_deal">
                                                            <div class="innner-heading-section">
                                                                <span>Add Outcome</span>
                                                            </div>
                                                            <ng-container *ngTemplateOutlet="outcomeConversionSection;"></ng-container>
                                                        </ng-container>
                                                    </ng-container>

                                                    <ng-container>
                                                        <div class="inner-checkbox-section">
                                                            <mat-checkbox [(ngModel)]="show_stage_move">Update Client Stage</mat-checkbox>
                                                        </div>
                                                        <ng-container *ngIf="show_stage_move">
                                                            <div class="innner-heading-section">
                                                                <span>Update Client Stage</span>
                                                            </div>
                                                            <ng-container *ngTemplateOutlet="clientMoveStageSection;"></ng-container>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
												<div class="activities-button-section">
													<button class="page-modal-primary-button" (click)="saveCaptureResponseData(activity)">Save</button>
													<button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
												</div>
											</ng-container>

											<ng-container *ngIf="activity_opeartion_selected == 'Activity Operations'">
												<div class="innner-heading-section">
													<span>{{activity_operation_type}} Activity</span>
												</div>
												<ng-container *ngTemplateOutlet="activityOperationSection;"></ng-container>
												<div class="activities-button-section">
													<button class="page-modal-primary-button" (click)="saveTaskData()">Save</button>
													<button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
												</div>
											</ng-container>

                                            <ng-container *ngIf="activity_opeartion_selected == 'Reasssign Activity'">
												<div class="innner-heading-section">
													<span>Reassign Activity</span>
												</div>
												<ng-container *ngTemplateOutlet="assignTaskSection;"></ng-container>
												<div class="activities-button-section">
													<button class="page-modal-primary-button" (click)="saveAssignTask()">Save</button>
													<button class="page-modal-secondary-button" (click)="resetAssignTaskData()">Cancel</button>
												</div>
											</ng-container>

                                            <ng-container *ngIf="activity_opeartion_selected == 'Assign Comments'">
												<div class="innner-heading-section">
													<span>{{activity.lead_advisor_full_name}} Commented "<strong>{{activity.lead_advisor_comments}}</strong>"</span>
												</div>
												<div class="activities-button-section">
													<button class="page-modal-secondary-button" (click)="resetAssignCommentsData()">Cancel</button>
												</div>
											</ng-container>

                                            <ng-container *ngIf="activity_opeartion_selected == 'Notify Comments'">
												<div class="innner-heading-section">
													<span>{{notify_comments_data.afa_name}} Comments</span>
												</div>
                                                <div class="activities-button-section">
													<table class="activity-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Date</th>
                                                                <th>Comments</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor=" let comment of notify_comments_data.afa_comments; let index = index">
                                                                <td>{{ comment.comment_date | date: "dd-MMM-yyyy" }}</td>
                                                                <td>{{ comment.description }}</td>
                                                            </tr>
                                                        </tbody>
													</table>
												</div>
												<div class="activities-button-section">
													<button class="page-modal-secondary-button" (click)="resetNotifyCommentsData()">Cancel</button>
												</div>
											</ng-container>

                                            <ng-container *ngIf="activity_opeartion_selected == 'Notify Activity'">
												<div class="innner-heading-section">
													<span>Notify Activity</span>
												</div>
                                                <ng-container *ngTemplateOutlet="notifyTaskSection;"></ng-container>
												<div class="activities-button-section">
                                                    <button class="page-modal-primary-button" (click)="saveNotifyTask()">Save</button>
													<button class="page-modal-secondary-button" (click)="resetNotifyTaskData()">Cancel</button>
												</div>
											</ng-container>

											<ng-container *ngIf="activity_opeartion_selected == 'Comments'">
												<div class="innner-heading-section">
													<span>Comments</span>
												</div>
												<div class="activities-button-section">
													<table class="activity-table">
														<thead>
															<tr>
																<th>Date</th>
																<th>Comments</th>
																<!-- Remove Delete <th>Action</th> -->
															</tr>
														</thead>
														<tbody>
															<tr *ngFor="let comment of comments_list;">
																<td>{{ comment.comment_date | date: "dd-MMM-yyyy" }}</td>
																<td style="overflow: hidden;" [innerHTML]="comment.description"></td>
																<!-- Remove Delete <td>
																	<img src="assets/delete-icon.png" class="activity-table-icon" (click)="deleteComment(comment)" />
																</td> -->
															</tr>
															<tr>
																<td colspan="9">
																	<span class="activity-table-icon" (click)="comment_operation_type = 'Add'">+ Add New Comment</span>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
												<ng-container *ngIf="comment_operation_type != ''">
													<ng-container *ngTemplateOutlet="commentsSection;"></ng-container>
													<div class="activities-button-section">
														<button class="page-modal-primary-button" (click)="saveComment()">Save</button>
														<button class="page-modal-secondary-button" (click)="resetCommentData()">Cancel</button>
													</div>
												</ng-container>
											</ng-container>

											<ng-container *ngIf="activity_opeartion_selected == 'Attachments'">
												<div class="innner-heading-section">
													<span>Attachments</span>
												</div>
												<div class="activities-button-section">
													<table class="activity-table">
														<thead>
															<tr>
																<th>Actions</th>
																<th>Attachment Name</th>
																<th>Download Attachment</th>
																<th>Comments</th>
															</tr>
														</thead>
														<tbody>
															<ng-container *ngFor="let attachment of attachments_list;">
																<tr>
																	<td>
																		<img src="assets/edit-client.png" class="activity-table-icon" (click)="openAttachmentOperation(attachment, 'Edit', index)" />
																		<!-- Remove Delete <img src="assets/delete-icon.png" class="activity-table-icon" (click)="removeAttachment(attachment, index)" /> -->
																	</td>
																	<td style="overflow: hidden;" [matTooltip]="attachment.attachment_filename">{{attachment.attachment_filename}}</td>
																	<td>
																		<img src="assets/download-icon-blue.png" class="activity-table-icon" (click)="downloadAttachment(attachment)" />
																	</td>
																	<td style="overflow: hidden;" [matTooltip]="attachment.comments">
																		<p class="overflow-text">{{attachment.comments}}</p>
																	</td>
																</tr>
																<tr *ngIf="attachment.id == attachment_data.id">
																	<td colspan="4">
																		<ng-container>
																			<ng-container *ngTemplateOutlet="attachmentsSection;"></ng-container>
																			<div class="activities-button-section">
																				<button class="page-modal-primary-button" (click)="saveAttachment()">Save</button>
																				<button class="page-modal-secondary-button" (click)="resetAttachmentData()">Cancel</button>
																			</div>
																		</ng-container>
																	</td>
																</tr>
															</ng-container>
															<tr>
																<td colspan="4">
																	<span class="activity-table-icon" (click)=" openAttachmentOperation(attachment_data, 'Add', null)">+ Add New Attachment</span>
																</td>
															</tr>
															<tr *ngIf="attachment_operation_type != ''">
																<td colspan="4">
																	<ng-container >
																		<ng-container *ngTemplateOutlet="attachmentsSection;"></ng-container>
																		<div class="activities-button-section">
																			<button class="page-modal-primary-button" (click)="saveAttachment()">Save</button>
																			<button class="page-modal-secondary-button" (click)="resetAttachmentData()">Cancel</button>
																		</div>
																	</ng-container>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</ng-container>

											<ng-container *ngIf="activity_opeartion_selected == 'Products'">
												<div class="innner-heading-section">
													<span>Close Deal</span>
												</div>
												<ng-container *ngTemplateOutlet="productConversionSection;"></ng-container>
												<div class="activities-button-section">
													<button class="page-modal-primary-button" (click)="addProduct()">Save</button>
													<button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
												</div>
											</ng-container>

											<ng-container *ngIf="activity_opeartion_selected == 'Outcome'">
												<div class="innner-heading-section">
													<span>Change Outcome</span>
												</div>
												<ng-container *ngTemplateOutlet="outcomeConversionSection;"></ng-container>
												<div class="activities-button-section">
													<button class="page-modal-primary-button" (click)="addOutcome()">Save</button>
													<button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
												</div>
											</ng-container>

										</div>
									</td>
								</tr>
							</ng-container>
						</tbody>
						<tbody *ngIf="activities.length == 0">
							<tr>
								<td [attr.colspan]="activities_table_header.length + 1">
                                <!-- <td colspan="7"> -->
									<div style="text-align: center">
										<span>No Activities Found</span>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
            </ng-container>
            <ng-container *ngIf="activities_loader">
                <app-loader [loading_text]="'Loading'"></app-loader>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #captureResponseSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Response Status</p>
            <mat-select class="page-input" [(ngModel)]="capture_response_data.response_status">
                <mat-option [value]="''">Select Response Status</mat-option>
                <mat-option [value]="'Interested'">Interested</mat-option>
                <mat-option [value]="'Not Interested'">Not Interested</mat-option>
                <mat-option [value]="'No Contact'">No Contact</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="capture_response_data_errors.response_status">Response Status is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Response Channel</p>
            <mat-select class="page-input" [(ngModel)]="capture_response_data.response_channel">
                <mat-option [value]="''">Select Response Channel</mat-option>
                <mat-option *ngFor="let communication_type of communication_type_list" [value]="communication_type.id">{{communication_type.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="capture_response_data_errors.response_channel">Response Channel is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Response Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="capture_response_data.response_capture_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="capture_response_data_errors.response_capture_date">Response Date is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Response Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="capture_response_data.response_comments"></textarea>
            <p class="page-input-error" *ngIf="capture_response_data_errors.response_comments">Response Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #activityOperationSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Activity Name</p>
            <!-- <input type="text" class="page-input" [(ngModel)]="activity_data.name" /> -->
            <mat-select class="page-input" [(ngModel)]="activity_data.name">
                <mat-option [value]="''">Select Activity Name</mat-option>
                <mat-option *ngFor="let task_name of task_names_list" [value]="task_name.name">{{task_name.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="activity_data_errors.name">Activity Name is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Scheduled Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="activity_data.scheduled_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="activity_data_errors.scheduled_date">Scheduled Date is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Actual Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="activity_data.actual_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="activity_data_errors.actual_date">Actual Date is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Description</p>
            <!-- <textarea class="page-input page-textarea" [(ngModel)]="activity_data.description"></textarea> -->
            <app-textarea-tagging [value]="activity_data.description" [users]="tagging_users_list" (valueChanged)="activity_data.description = $event"></app-textarea-tagging>
            <p class="page-input-error" *ngIf="activity_data_errors.description">Description is Required.</p>
        </div>
        <div class="page-input-section">
            <p class="page-input-label">Communication Channel</p>
            <mat-select class="page-input" [(ngModel)]="activity_data.communication_type">
                <mat-option [value]="''">Select Communication Channel</mat-option>
                <mat-option *ngFor="let communication of communication_type_list" [value]="communication.id">{{ communication.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="activity_data_errors.communication_type">Communication Channel is Required.</p>
        </div>
        <!-- <div class="page-input-section page-input-small"> -->
		<div class="page-input-section">
            <p class="page-input-label">Status</p>
            <mat-select class="page-input" [(ngModel)]="activity_data.status">
                <mat-option [value]="''">Select Status</mat-option>
                <mat-option *ngFor="let status of status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="activity_data_errors.status">Status is Required.</p>
        </div>
        <!-- <div class="page-input-section page-input-small">
            <p class="page-input-label">Assign</p>
            <mat-select class="page-input" [(ngModel)]="activity_data.afa_id">
                <mat-option [value]="''">Self</mat-option>
                <mat-option *ngFor="let afa of afa_list" [value]="afa.id">{{ afa.first_name }} {{ afa.last_name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="activity_data_errors.afa_id">Assign is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Assign Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="activity_data.afa_comments"></textarea>
            <p class="page-input-error" *ngIf="activity_data_errors.afa_comments">Assign Comments is Required.</p>
        </div> -->
    </div>
</ng-template>

<ng-template #manualActivityOperationSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Activity Name</p>
            <!-- <input type="text" class="page-input" [(ngModel)]="manual_activity_data.name" /> -->
            <mat-select class="page-input" [(ngModel)]="manual_activity_data.name">
                <mat-option [value]="''">Select Activity Name</mat-option>
                <mat-option *ngFor="let task_name of task_names_list" [value]="task_name.name">{{task_name.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.name">Activity Name is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Scheduled Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="manual_activity_data.scheduled_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="manual_activity_data_errors.scheduled_date">Scheduled Date is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Actual Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="manual_activity_data.actual_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="manual_activity_data_errors.actual_date">Actual Date is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Description</p>
            <!-- <textarea class="page-input page-textarea" [(ngModel)]="manual_activity_data.description"></textarea> -->
            <app-textarea-tagging [value]="manual_activity_data.description" [users]="tagging_users_list" (valueChanged)="manual_activity_data.description = $event"></app-textarea-tagging>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.description">Description is Required.</p>
        </div>
        <div class="page-input-section">
            <p class="page-input-label">Communication Channel</p>
            <mat-select class="page-input" [(ngModel)]="manual_activity_data.communication_type">
                <mat-option [value]="''">Select Communication Channel</mat-option>
                <mat-option *ngFor="let communication of communication_type_list" [value]="communication.id">{{ communication.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.communication_type">Communication Channel is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Status</p>
            <mat-select class="page-input" [(ngModel)]="manual_activity_data.status">
                <mat-option [value]="''">Select Status</mat-option>
                <mat-option *ngFor="let status of status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.status">Status is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Assign</p>
            <mat-select class="page-input" [(ngModel)]="manual_activity_data.afa_id">
                <mat-option [value]="''">Self</mat-option>
                <mat-option *ngFor="let afa of afa_list" [value]="afa.id">{{ afa.first_name }} {{ afa.last_name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.afa_id">Assign is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Assign Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="manual_activity_data.afa_comments"></textarea>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.afa_comments">Assign Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #assignTaskSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Assignee</p>
            <mat-select class="page-input" [(ngModel)]="assign_task_data.afa">
                <mat-option [value]="''">Select Assignee</mat-option>
                <mat-option *ngFor="let afa of afa_list" [value]="afa.id">{{ afa.first_name }} {{ afa.last_name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="assign_task_data_errors.afa">Assignee is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Initial Target Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="activity_data.scheduled_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                [disabled]="true"
            />
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Revised Target Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="assign_task_data.target_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="assign_task_data_errors.target_date">Revised Target Date is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="assign_task_data.afa_comments"></textarea>
            <p class="page-input-error" *ngIf="assign_task_data_errors.afa_comments">Assign Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #notifyTaskSection>
    <div class="capture-response-section">
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="notify_advisor_comments"></textarea>
            <p class="page-input-error" *ngIf="notify_advisor_comments_error">Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #commentsSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="comment_data.comment_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="comment_data_errors.comment_date">Date is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="comment_data.description"></textarea>
            <p class="page-input-error" *ngIf="comment_data_errors.description">Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #attachmentsSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <!-- <p class="page-input-label">Upload Attachment</p> -->
            <input type="file" #file_upload style="display: none;" (change)="uploadAttachment($event)" />
            <button class="page-modal-primary-button" (click)="file_upload.click()">Upload Attachment</button>
            <span>{{attachment_data.attachment_filename}}</span>
            <p class="page-input-error" *ngIf="attachment_data_errors.attachment_filename">Attachment is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="attachment_data.comments"></textarea>
            <p class="page-input-error" *ngIf="attachment_data_errors.comments">Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #productsSection>
    <div class="automated-activities-section">
        <!-- <div class="automated-activities-header-section">
            <div class="automated-activities-heading-section">
                <img src="assets/automated-activities.png" class="automated-activities-heading-icon" />
                <span>Products</span>
            </div>
        </div> -->
        <div class="automated-activities-content-section">
            <ng-container *ngIf="!products_list_loader">
                <table class="activity-table">
                    <thead>
                        <tr>
                            <th appColumnResizable *ngIf="selected_view_type != 'View'">Actions</th>
                            <th appColumnResizable>
                                <span *ngIf="user_role != 'Relationship Manager'">Policy Number</span>
                                <span *ngIf="user_role == 'Relationship Manager'">Deposit Number</span>
                            </th>
                            <th appColumnResizable>Product</th>
                            <th appColumnResizable>AUM</th>
                            <th appColumnResizable *ngIf="user_role == 'Relationship Manager'">Purpose</th>
                            <th appColumnResizable>Activated Date</th>
                            <th appColumnResizable>Status</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="products_list.length > 0">
                        <ng-container *ngFor="let product of products_list; let index = index;">
                            <tr>
                                <td style="overflow: visible;" *ngIf="selected_view_type != 'View'">
                                    <div class="more-details-section">
                                        <img src="assets/more-icon.png" class="more-details-icon" (click)="toggleActivityOptionsView(index)" />
                                        <div class="more-options-section" *ngIf="show_more_options == index">
                                            <p class="each-more-option" (click)="productOpeartion(product, 'Edit', index, 'Wealth Growth')">Edit Product</p>
                                            <p class="each-more-option" (click)="removeProduct(product)">Delete Product</p>
                                        </div>
                                    </div>
                                </td>
                                <td>{{product.policy_number}}</td>
                                <td>{{product.product_name}}</td>
                                <td>{{product.amount}}</td>
                                <td *ngIf="user_role == 'Relationship Manager'">{{product.deposit_purpose}}</td>
                                <td>
                                    {{product.start_date | date: "dd MMM yyyy"}}
                                </td>
                                <td>
                                    <span [ngClass]="{'activity-status-pending': product.client_product_status_name == 'In Active', 'activity-status-progress': product.client_product_status_name == 'Active', 'activity-status-completed': product.client_product_status_name == 'Completed'}">{{ product.client_product_status_name }}</span>
                                </td>
                            </tr>
                            <tr *ngIf="show_inner_view == index">
                                <td colspan="7">
                                    <div class="activities-inner-view-section">
                                        <div class="innner-heading-section">
                                            <span>Edit Product</span>
                                        </div>
                                        <!-- <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container> -->
                                        <ng-container *ngIf="user_details.role.business_area[0] == '5'">
                                            <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="user_details.role.business_area[0] == '6'">
                                            <ng-container *ngTemplateOutlet="depositProductOperationSection;"></ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="user_details.role.business_area[0] == '7'">
                                            <ng-container *ngTemplateOutlet="lendingProductOperationSection;"></ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="user_details.role.business_area[0] == '8'">
                                            <ng-container *ngTemplateOutlet="insuranceProductOperationSection;"></ng-container>
                                        </ng-container>
                                        <div class="activities-button-section">
                                            <button class="page-modal-primary-button" (click)="updateProduct()">Save</button>
                                            <button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                    <tbody *ngIf="products_list.length == 0">
                        <tr>
                            <td colspan="7">
                                <div style="text-align: center">
                                    <span>No Products Found</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
            <ng-container *ngIf="products_list_loader">
                <app-loader [loading_text]="'Loading Client Products'"></app-loader>
            </ng-container>
        </div>
    </div>
</ng-template>




<ng-template #depositProductsSection>
    <div class="automated-activities-section">
        <!-- <div class="automated-activities-header-section">
            <div class="automated-activities-heading-section">
                <img src="assets/automated-activities.png" class="automated-activities-heading-icon" />
                <span>Products</span>
            </div>
        </div> -->
        <div class="automated-activities-content-section">
            <ng-container *ngIf="!products_list_loader">
                <table class="activity-table">
                    <thead>
                        <tr>
                            <th appColumnResizable *ngIf="selected_view_type != 'View'">Actions</th>
                            <th appColumnResizable>Product</th>
                            <th appColumnResizable>
                                <span>Policy Number</span>
                            </th>
                            <th appColumnResizable>Amount</th>
                            <th appColumnResizable>Activated Date</th>
                            <th appColumnResizable>Valid Until</th>
                            <th appColumnResizable >Interest Rate</th>
                            <th appColumnResizable >Monthly Fees</th>
                            <th appColumnResizable >Type</th>
                            <th appColumnResizable>Status</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="products_list.length > 0">
                        <ng-container *ngFor="let product of products_list; let index = index;">
                            <tr>
                                <td style="overflow: visible;" *ngIf="selected_view_type != 'View'">
                                    <div class="more-details-section">
                                        <img src="assets/more-icon.png" class="more-details-icon" (click)="toggleActivityOptionsView(index)" />
                                        <div class="more-options-section" *ngIf="show_more_options == index">
                                            <p class="each-more-option" (click)="productOpeartion(product, 'Edit', index, 'Deposit Growth')">Edit Product</p>
                                            <p class="each-more-option" (click)="removeProduct(product)">Delete Product</p>
                                        </div>
                                    </div>
                                </td>
                                <td>{{product.product_name}}</td>
                                <td>{{product.policy_number}}</td>
                                <td>{{product.amount}}</td>
                                <td>
                                    {{product.start_date | date: "dd MMM yyyy"}}
                                </td>
                                <td>
                                    {{product.close_date | date: "dd MMM yyyy"}}
                                </td>
                                <td>{{product.interest_rate}}</td>
                                <td>{{product.monthly_fees}}</td>
                                <td>{{product.type}}</td>
                                <!-- <td >{{product.deposit_purpose}}</td> -->
                                <td>
                                    <span [ngClass]="{'activity-status-pending': product.client_product_status_name == 'In Active', 'activity-status-progress': product.client_product_status_name == 'Active', 'activity-status-completed': product.client_product_status_name == 'Completed'}">{{ product.client_product_status_name }}</span>
                                </td>
                            </tr>
                            <tr *ngIf="show_inner_view == index">
                                <td colspan="7">
                                    <div class="activities-inner-view-section">
                                        <div class="innner-heading-section">
                                            <span>Edit Product</span>
                                        </div>
                                        <!-- <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container> -->
                                        <ng-container *ngIf="user_details.role.business_area[0] == '5'">
                                            <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="user_details.role.business_area[0] == '6'">
                                            <ng-container *ngTemplateOutlet="depositProductOperationSection;"></ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="user_details.role.business_area[0] == '7'">
                                            <ng-container *ngTemplateOutlet="lendingProductOperationSection;"></ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="user_details.role.business_area[0] == '8'">
                                            <ng-container *ngTemplateOutlet="insuranceProductOperationSection;"></ng-container>
                                        </ng-container>
                                        <div class="activities-button-section">
                                            <button class="page-modal-primary-button" (click)="updateProduct()">Save</button>
                                            <button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                    <tbody *ngIf="products_list.length == 0">
                        <tr>
                            <td colspan="7">
                                <div style="text-align: center">
                                    <span>No Products Found</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
            <ng-container *ngIf="products_list_loader">
                <app-loader [loading_text]="'Loading Client Products'"></app-loader>
            </ng-container>
        </div>
    </div>
</ng-template>




<ng-template #productConversionSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Conversion Status *</p>
            <mat-select class="page-input" [(ngModel)]="conversion_status_data.conversion_status" >
                <mat-option [value]="''">Select Conversion Status</mat-option>
                <mat-option *ngFor="let conversion_status of conversion_status_list" [value]="conversion_status.id" (click)=" conversion_status_data.conversion_status_name = conversion_status.name ">{{ conversion_status.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="conversion_status_data_errors.conversion_status">Conversion Status is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Comments *</p>
            <textarea class="page-input page-textarea" [(ngModel)]="conversion_status_data.conversion_comments"></textarea>
            <p class="page-input-error" *ngIf="conversion_status_data_errors.conversion_comments">Comments is Required.</p>
        </div>


        <ng-container *ngIf="conversion_status_data.conversion_status == 1">
            <ng-container *ngIf="user_details.role.business_area[0] == '5'">
                <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
            </ng-container>
            <ng-container *ngIf="user_details.role.business_area[0] == '6'">
                <ng-container *ngTemplateOutlet="depositProductOperationSection;"></ng-container>
            </ng-container>
            <ng-container *ngIf="user_details.role.business_area[0] == '7'">
                <ng-container *ngTemplateOutlet="lendingProductOperationSection;"></ng-container>
            </ng-container>
            <ng-container *ngIf="user_details.role.business_area[0] == '8'">
                <ng-container *ngTemplateOutlet="insuranceProductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-template>



<ng-template #productOperationSection>
    <div>
        <div class="page-input-section">
            <p class="page-input-label" *ngIf="user_role != 'Relationship Manager'">Policy Number *</p>
            <p class="page-input-label" *ngIf="user_role == 'Relationship Manager'">Deposit Number *</p>
            <input type="text" class="page-input" [(ngModel)]="product_data.policy_number" />
            <p class="page-input-error" *ngIf="product_data_errors.policy_number">
                <span *ngIf="user_role != 'Relationship Manager'">Policy Number</span>
                <span *ngIf="user_role == 'Relationship Manager'">Deposit Number</span>
                is Required.
            </p>
        </div>
    </div>
    <div>
        <div class="page-input-section">
            <p class="page-input-label">AUM *</p>
            <input type="text" class="page-input" [(ngModel)]="product_data.aum" (keypress)="numberOnly($event)" />
            <p class="page-input-error" *ngIf="product_data_errors.aum">AUM is Required.</p>
        </div>
    </div>
    <div>
        <div class="page-input-section">
            <p class="page-input-label">Product *</p>
            <mat-select class="page-input" [(ngModel)]="product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="product_data_errors.product">Product is Required.</p>
        </div>
    </div>
    <div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Activated Date *</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="product_data_errors.start_date">Activated Date is Required.</p>
        </div>
        <div class="page-input-section page-input-small" *ngIf="getProductType(product_data.product)">
            <p class="page-input-label">Valid Until *</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="product_data.close_date"
                [minDate]="product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="product_data.start_date == '' || product_data.start_date == null" -->
            <p class="page-input-error" *ngIf="product_data_errors.close_date">Valid Until is Required.</p>
        </div>
    </div>
    <div>
        <div class="page-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="page-input-label">Purpose *</p>
            <mat-select class="page-input" [(ngModel)]="product_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="product_data_errors.deposit_purpose">Purpose is Required.</p>
        </div>
    </div>
    <div>
        <div class="page-input-section">
            <p class="page-input-label">Type *</p>
            <mat-select class="page-input" [(ngModel)]="product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="product_data_errors.type">Type is Required.</p>
        </div>
    </div>
    <div>
        <div class="page-input-section">
            <p class="page-input-label">Client Product Status *</p>
            <mat-select class="page-input" [(ngModel)]="product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
    <div>
        <div class="page-input-section">
            <p class="page-input-label">Financial Institution Branch *</p>
            <mat-select class="page-input" [(ngModel)]="product_data.financial_institution_branch">
                <mat-option [value]="''">Select Financial Institution Branch</mat-option>
                    <mat-option *ngFor="let branch of financial_institution_branch_list" [value]="branch.id">{{branch.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="product_data_errors.financial_institution_branch">Financial Institution Branch is Required.</p>
        </div>
    </div>
</ng-template>


<!-- deposit Product Operation Section Start -->
<ng-template #depositProductOperationSection>
    <div class="capture-response-section">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(depositProduct_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="depositProduct_data_errors.product">Product is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Policy Number *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.policy_number" />
            <p class="page-input-error" *ngIf="depositProduct_data_errors.policy_number">Policy Number is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Amount *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.aum" (input)="checkAmountValidation(depositProduct_data.product, depositProduct_data.aum)" (keypress)="numberOnly($event)" />
            <p class="page-input-error" *ngIf="depositProduct_data_errors.aum">Amount is Required.</p>
            <p class="page-input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Start Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="depositProduct_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="depositProduct_data_errors.start_date">Activated Date is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="depositProduct_data.close_date"
                [minDate]="depositProduct_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="depositProduct_data.start_date == '' || depositProduct_data.start_date == null" -->
            <p class="page-input-error" *ngIf="depositProduct_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="depositProduct_data_errors.deposit_purpose">Purpose is Required.</p>
        </div> -->


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Tenure (Months) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.tenure" />
            <p class="page-input-error" *ngIf="depositProduct_data_errors.tenure">
                <span>Tenure</span>
                is Required.
            </p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Interest Rate (%) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.interest_rate" (keypress)="validateMaxValue($event, 100)" />
            <p class="page-input-error" *ngIf="depositProduct_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Monthly Fees *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.monthly_fees" />
            <p class="page-input-error" *ngIf="depositProduct_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="depositProduct_data_errors.type">Type is Required.</p>
        </div>



        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="depositProduct_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>
<!-- deposit Product Operation Section End -->

<!-- Lending Product Operation Section Start -->
<ng-template #lendingProductOperationSection>
    <div class="capture-response-section">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(lending_product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="lending_product_data_errors.product">Product is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Policy Number *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.policy_number" />
            <p class="page-input-error" *ngIf="lending_product_data_errors.policy_number">Policy Number is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Amount *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.aum" (input)="checkAmountValidation(lending_product_data.product, lending_product_data.aum)" (keypress)="numberOnly($event)" />
            <p class="page-input-error" *ngIf="lending_product_data_errors.aum">Amount is Required.</p>
            <p class="page-input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Start Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="lending_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="lending_product_data_errors.start_date">Activated Date is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="lending_product_data.close_date"
                [minDate]="lending_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="lending_product_data.start_date == '' || lending_product_data.start_date == null" -->
            <p class="page-input-error" *ngIf="lending_product_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="lending_product_data_errors.deposit_purpose">Purpose is Required.</p>
        </div> -->


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Tenure (Months) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.tenure" />
            <p class="page-input-error" *ngIf="lending_product_data_errors.tenure">
                <span>Tenure</span>
                is Required.
            </p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Interest Rate (%) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.interest_rate" (keypress)="validateMaxValue($event, 100)" />
            <p class="page-input-error" *ngIf="lending_product_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Monthly Fees *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.monthly_fees" />
            <p class="page-input-error" *ngIf="lending_product_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="lending_product_data_errors.type">Type is Required.</p>
        </div>



        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="lending_product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>
<!-- Lending Product Operation Section End -->

<!-- Insurance Product Operation Section Start -->
<ng-template #insuranceProductOperationSection>
    <div class="capture-response-section">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(insurance_product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="insurance_product_data_errors.product">Product is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Policy Number *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.policy_number" />
            <p class="page-input-error" *ngIf="insurance_product_data_errors.policy_number">Policy Number is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Amount *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.aum" (input)="checkAmountValidation(insurance_product_data.product, insurance_product_data.aum)" (keypress)="numberOnly($event)" />
            <p class="page-input-error" *ngIf="insurance_product_data_errors.aum">Amount is Required.</p>
            <p class="page-input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Start Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="insurance_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="insurance_product_data_errors.start_date">Activated Date is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="insurance_product_data.close_date"
                [minDate]="insurance_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="insurance_product_data.start_date == '' || insurance_product_data.start_date == null" -->
            <p class="page-input-error" *ngIf="insurance_product_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="insurance_product_data_errors.deposit_purpose">Purpose is Required.</p>
        </div> -->


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Tenure (Months) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.tenure" />
            <p class="page-input-error" *ngIf="insurance_product_data_errors.tenure">
                <span>Tenure</span>
                is Required.
            </p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Interest Rate (%) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.interest_rate" (keypress)="validateMaxValue($event, 100)" />
            <p class="page-input-error" *ngIf="insurance_product_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Monthly Fees *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.monthly_fees" />
            <p class="page-input-error" *ngIf="insurance_product_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="insurance_product_data_errors.type">Type is Required.</p>
        </div>



        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="insurance_product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>
<!-- Insurance Product Operation Section End -->




<ng-template #automatedActivitiesOperationModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Activity Operation</span>
            <span class="client-modal-icon" (click)="closeAutomatedActivityOperationModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description" *ngIf="automated_activities_operation_type != 'Individual'">
                Do you want to stop the
                <span *ngIf="selected_activities.length != 1">activities</span>
                <span *ngIf="selected_activities.length == 1">activity</span>
            </p>
            <p class="page-modal-delete-description" *ngIf="automated_activities_operation_type == 'Individual'">
                Do you want to
                <span *ngIf="selected_activities[0].activity_paused">resume</span>
                <span *ngIf="!selected_activities[0].activity_paused">stop</span> the activity
            </p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="automatedActivityOperation()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeAutomatedActivityOperationModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #activitiesDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Activity</span>
            <span class="client-modal-icon" (click)="closeDeleteActivityModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteActivity()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteActivityModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #attachmentDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Attachment Details</span>
            <span class="client-modal-icon" (click)="closeDeleteAttachmentModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteAttachment()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteAttachmentModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #productDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Product</span>
            <span class="client-modal-icon" (click)="closeDeleteProductModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteProduct()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteProductModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #outcomeConversionSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Outcome Status *</p>
            <mat-select class="page-input" [(ngModel)]="outcome_data.attrition_status" >
                <mat-option [value]="''">Select Outcome Status</mat-option>
                <mat-option [value]="'Retained'">Retained</mat-option>
                <mat-option [value]="'Retained, Upside'">Retained, Upside</mat-option>
                <mat-option [value]="'Likely to Switch Advisor'">Likely to Switch Advisor</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="outcome_data_errors.attrition_status">Outcome Status is Required.</p>
        </div>
        <div class="page-input-section page-input-large" *ngIf="outcome_data.attrition_status == 'Likely to Switch Advisor'">
            <p class="page-input-label">Reason *</p>
            <mat-select class="page-input" [(ngModel)]="outcome_data.attrition_comments" >
                <mat-option [value]="''">Select Reason</mat-option>
                <mat-option *ngFor="let attrition_reason of attrition_reasons_list" [value]="attrition_reason.name">{{attrition_reason.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="outcome_data_errors.attrition_comments">Reason is Required.</p>
        </div>
        <div class="page-input-section page-input-large" *ngIf="outcome_data.attrition_status != 'Likely to Switch Advisor'">
            <p class="page-input-label">Comments *</p>
            <textarea class="page-input page-textarea" [(ngModel)]="outcome_data.attrition_comments"></textarea>
            <p class="page-input-error" *ngIf="outcome_data_errors.attrition_comments">Comments is Required.</p>
        </div>
        <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
            <!-- <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container> -->
            <ng-container *ngIf="user_details.role.business_area[0] == '5'">
                <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
            </ng-container>
            <ng-container *ngIf="user_details.role.business_area[0] == '6'">
                <ng-container *ngTemplateOutlet="depositProductOperationSection;"></ng-container>
            </ng-container>

            <ng-container *ngIf="user_details.role.business_area[0] == '7'">
                <ng-container *ngTemplateOutlet="lendingProductOperationSection;"></ng-container>
            </ng-container>
            <ng-container *ngIf="user_details.role.business_area[0] == '8'">
                <ng-container *ngTemplateOutlet="insuranceProductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #clientMoveStageSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Select Stage</p>
            <mat-select class="page-input" [(ngModel)]="move_stage_data.stage" >
                <mat-option [value]="''">Select Stage</mat-option>
                <mat-option *ngFor="let stage of stages_list" [value]="stage.id">{{ stage.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="move_stage_data_errors.stage">Stage is Required.</p>
        </div>
        <div>
            <div class="page-input-section">
                <mat-checkbox [(ngModel)]="move_stage_data.activity_status">Mark Stage Activities as Not Required</mat-checkbox>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #activityEmailPreviewModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>{{ activity_email_data.template_name }}</span>
            <span class="page-modal-close-icon" (click)="closeActivityEmailPreviewModal()">&times;</span>
        </div>
        <div class="page-modal-content-section" *ngIf="activity_email_data_loaded">
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Subject: {{ activity_email_data.subject }}</p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Email Body:</p>
                <p class="page-modal-input-label" [innerHTML]="getHTML(activity_email_data.email_body)">{{ activity_email_data.template_name }}</p>
            </div>
            <div class="page-modal-input-section" *ngIf=" activity_email_data.greetings_image != '' && activity_email_data.greetings_image != null ">
                <button class="page-modal-primary-button" (click)="download(activity_email_data.greetings_image)" >Download Attachment</button>
            </div>
        </div>
        <div class="page-modal-content-section" *ngIf="!activity_email_data_loaded">
            <app-loader [loading_text]="'Loading'"></app-loader>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-secondary-button" (click)="closeActivityEmailPreviewModal()">Cancel</button>
        </div>
    </div>
</ng-template>

<!-- <ng-container *ngIf="show_activity_details">
    <app-activity-details [data]="show_activity_data" [stepper_stage]="stepper_stage" (activityDetailsClosed)="activityDetailsClosed($event)"></app-activity-details>
</ng-container> -->
